class InstacartService {
  /**
   * Create an Instacart shopping list
   * 
   * @param {Array} ingredients - Array of ingredient objects
   * @param {string} recipeTitle - Title for the shopping list
   * @param {string} menuItemUrl - Linkback URL
   * @param {string|null} menuItemId - Single menu item ID (for single menu purchases)
   * @param {Object} options - Additional options for attribution tracking
   * @param {string} options.nutritionGoalId - Nutrition plan goal ID
   * @param {string} options.coachAffiliateId - Coach's affiliate ID for attribution
   * @param {string} options.clientId - Client ID (for coach-created plans)
   * @param {Array} options.menuItemIds - Array of menu item IDs in the plan
   */
  async createShoppingList(ingredients, recipeTitle, menuItemUrl, menuItemId, options = {}) {
    try {
      console.log('Fetching Instacart shopping list');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/instacart/shopping-list`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}` // Your auth token
        },
        body: JSON.stringify({
          ingredients,
          recipeTitle,
          menuItemUrl,
          menuItemId,
          // Nutrition plan attribution parameters
          nutritionGoalId: options.nutritionGoalId || null,
          coachAffiliateId: options.coachAffiliateId || null,
          clientId: options.clientId || null,
          menuItemIds: options.menuItemIds || []
        })
      });
      console.log('Response received:', response);

      if (!response.ok) {
        throw new Error('Failed to create shopping list');
      }

      const data = await response.json();
      return data.url;
    } catch (error) {
      console.error('Error creating Instacart shopping list:', error);
      throw error;
    }
  }
}

export default InstacartService; 